import React, { Component } from 'react'
import SmoothCollapse from 'react-smooth-collapse'
import GanttChartBar from './gantt-chart-bar'
import { clone } from 'lodash'

import DeepDiff from 'deep-diff'
import isEqual from 'react-fast-compare'

import moment from 'moment'

export default class GanttChartTrack extends Component { 
	state = {
		hoveredRow: null,
	}

	shouldComponentUpdate = (nextProps, nextState) => {
		// Fucken, why?!
		if(isEqual(this.props, nextProps) && isEqual(this.state, nextState)){
			return false
		}

		return true
	}

	setHover = (rowIndex, isHovered) => {
		if(this.state.hoveredRow === rowIndex && !isHovered){
			this.setState({
				hoveredRow: null
			})
		}else if(this.state.hoveredRow !== rowIndex && isHovered){
			this.setState({
				hoveredRow: rowIndex
			})
		}
	}

    getDateFormat = (moment, type) => {
        const {
            zoomLevelIndex
        } = this.props

        let format = ''

        if(type == 'month'){
            if(zoomLevelIndex >= 2)
                format = 'MMMM Y'
            else{
                format = 'MMM'
            }
        }else{

        }

        return moment.format(format)
	}
	
	render() {
		const {
			currentProject,
			ganttData,
			columnData,
			isMilestoneCollapsed,
			handleResizeTask,
			handleMoveTask,
			interactedTaskId,
			setInteractedTaskId,
			toggleDragOrResize,
			chartRefOffsets,
			zoomLevelIndex,
			cellWidth,
			isDragging,
			chartRefs,
		} = this.props

		const {
			hoveredRow
		} = this.state

		let rowIncrementer = -1

		return (
			<div>
				<div className="dates" ref={ref => this.datesRef = ref}>
					{ganttData && columnData.columns.map((column, index) => {
						const day = parseInt(column.moment.format('DD'))

						const isToday = column.moment.isSame(moment(), 'day')

						let dayClassName = 'day'

						let smallValue = day

						if(columnData.unit == 'week'){
							let weekNumber = (index + 1)

							smallValue = zoomLevelIndex < 4 ? 'Wk. '+weekNumber : 'Week '+weekNumber
						}else{
							if(columnData.unit == 'day'){
								dayClassName += ' centred'
							}

							if (isToday) {
								dayClassName += ' today'
							}
						}

						let shouldShowMonth = false
						let monthPixelsFromLeft = 0
						let monthStartMoment = column.moment

						if(columnData.unit == 'week'){
							shouldShowMonth = false

							const endOfWeek = moment(column.moment).add(6, 'days')

							// month changes in this week
							if(!endOfWeek.isSame(column.moment, 'month')){
								monthStartMoment = moment(endOfWeek).startOf('month')

								const daysFromStartOfWeek = monthStartMoment.diff(column.moment, 'days')

								monthPixelsFromLeft = daysFromStartOfWeek * cellWidth

								shouldShowMonth = true
							}else if(day == 1){
								shouldShowMonth = true
							}
						}else if(columnData.unit == 'day'){
							shouldShowMonth = day == 1
						}else{
							shouldShowMonth = true
						}

						if(shouldShowMonth){
							const endOfMonthMoment = moment(column.moment).endOf('month').startOf('day')
							const daysLeftInMonth = endOfMonthMoment.diff(column.moment, 'days')

							if(zoomLevelIndex <= 2){
								if(daysLeftInMonth < 10){
									shouldShowMonth = false
								}
							}
						}

						let mainValue = smallValue
						let topValue = null

						const monthLabel = this.getDateFormat(monthStartMoment, 'month')

						// show year above
						if(zoomLevelIndex < 2){
							topValue = !column.moment.month() ? column.moment.format('Y') : null
							mainValue = shouldShowMonth ? monthLabel : null
						}else{
							topValue = shouldShowMonth ? monthLabel : null
						}

						if(zoomLevelIndex == 2){
							mainValue = null
						}

						return (
							<div 
								key={index} 
								style={{ width: column.width+'px' }}
								className={!mainValue ? 'month-only' : null}
							>
								{ topValue &&
									<div 
										className="month"
										style={{
											left: monthPixelsFromLeft+'px'
										}}
									>
										{ topValue }
									</div>
								}
								<div className={dayClassName}>
									{ mainValue ? mainValue : '&nbsp;' }
								</div>
							</div>
						)
					})}
				</div>
				<div className={isDragging ? "chart dragging" : "chart"}>
					<div className={"columns"} ref={ref => chartRefs.inner = ref}>
						{ganttData && columnData.columns.map((column, index) => {
							let isToday = false
							let isWeekend = false

							if(columnData.unit == 'day'){
								isToday = column.moment.isSame(moment(), 'day')

								const dayName = column.moment.format('dddd')
								isWeekend = dayName === 'Saturday' || dayName === 'Sunday'
							}

							let className = ''

							if(isToday){
								className += ' today'
							}

							if(isWeekend){
								className += ' weekend'
							}

							return (
								<div
									className={className}
									key={index}
									style={{
										width: column.width+'px'
									}}
								/>
							)
						})}
					</div>
					<div>
						{ganttData && ganttData.rowData.map((row, rowIndex) => {
							let completionWidth = null

							if (row.earliestMoment && row.latestMoment) {
								let daysFromToday = moment().diff(row.earliestMoment, 'days')

								if (daysFromToday > 0) {
									completionWidth = daysFromToday * cellWidth
								}
							}

							let rangeClassName = 'milestone-range'

							let isCollapsed = isMilestoneCollapsed(row.id)

							if(isCollapsed){
								rangeClassName += ' thick'
							}

							const showRange = !isNaN(row.startIndex) && !isNaN(row.endIndex) && row.startIndex !== row.endIndex

							return (
								<li className="gantt-milestone" key={rowIndex}>
									<h3>
										&nbsp;
										{showRange ?
											<div
												className={rangeClassName}
												style={{
													left: (row.startIndex * cellWidth) + 'px',
													width: ((row.endIndex - row.startIndex) * cellWidth) + 'px'
												}}
											>
												{completionWidth &&
													<div style={{ width: completionWidth + 'px' }} />
												}
											</div>
											: null}
									</h3>
									<SmoothCollapse 
										expanded={!isCollapsed}
										allowOverflowWhenOpen={true}
									>
										<ul className="gantt-task-list">
											{
												row.taskData.map(task => {
													let taskWidth = 1
													let taskStart = 0

													rowIncrementer += 1

													const thisRowIncrementer = clone(rowIncrementer)

													if (task.valid) {
														taskStart = task.startIndex * cellWidth
														taskWidth = (task.endIndex - task.startIndex) * cellWidth
													}

													const key = task.id+'_'+cellWidth // this is so 'default' is re-rendered whenever zoom changes

													return (
														<li key={key} className={hoveredRow === thisRowIncrementer ? 'hovered' : null}>
															<div className="gantt-row-spacer">
																&nbsp;
																{task.valid ?
																	<GanttChartBar 
																		currentProject={currentProject}
																		cellWidth={cellWidth}
																		taskStart={taskStart}
																		taskWidth={taskWidth}
																		handleResizeTask={handleResizeTask}
																		handleMoveTask={handleMoveTask}
																		interactedTaskId={interactedTaskId}
																		setInteractedTaskId={setInteractedTaskId}
																		task={task}
																		toggleDragOrResize={toggleDragOrResize}
																		setHover={isHovered => this.setHover(thisRowIncrementer, isHovered)}
																		hoveredRow={hoveredRow}
																		chartRefOffsets={chartRefOffsets}
																	/>
																	: null}
															</div>
														</li>
													)
												})
											}
										</ul>
									</SmoothCollapse>
								</li>
							)
						})}
					</div>
				</div>
			</div>
		)
	}
}
